<template>
  <div class="w-full max-w-270 text-app-color">
    <div class="w-full p-15 pt-10 pb-40 rounded-20 border border-grey-300"
         :class="isDarkMode ? 'bg-sidebar' : 'bg-white'"
    >
      <div class="text-center mt-30">
        <p class="text-26 font-semibold">FREE.</p>
        <p class="text-14">Great for simple note-taking <br> and organizing your life.</p>
        <div class="text-center mt-20">
          <div class="flex items-start justify-center -ml-10">
            <span>$</span>
            <span class="text-35 font-bold">{{ price }}</span>
          </div>
          <p class="leading-0">per month</p>
        </div>
      </div>

      <div class="text-center mt-35">
        <button
          class="border-2 transition-color duration-300 rounded-12 px-26 py-12 font-medium"
          :class="isDraculaTheme
            ? 'bg-notebooks-dracula-link hover:bg-canvasborder-notebooks-dracula-link'
            : isDarkMode
              ? 'bg-link-color hover:bg-canvas hover:text-link-color border-link-color'
              : 'border-blue-dark hover:bg-blue-dark hover:text-white '"
          :disabled="isFreePlan"
          @click="cancel"
        >
          {{ btnTitle }}
        </button>
      </div>

      <div class="flex justify-center mt-30">
        <div>
          <div class="flex items-center mt-5">
            <i class="icon-check text-green-400 text-20 font-bold mr-5" />
            <p class="text-14"><span class="font-bold">{{ freePlan.maxBooks }}</span> spaces</p>
          </div>
          <div class="flex items-center mt-5">
            <i class="icon-check text-green-400 text-20 font-bold mr-5" />
            <p class="text-14"><span class="font-bold">{{ freePlan.maxProjects }}</span> pages</p>
          </div>
          <div class="flex items-center mt-5">
            <i class="icon-check text-green-400 text-20 font-bold mr-5" />
            <p class="text-14"><span class="font-bold">{{ maxSize }}MB</span> storage</p>
          </div>
          <div class="flex items-center mt-5">
            <i class="icon-check text-green-400 text-20 font-bold mr-5" />
            <p class="text-14"><span class="font-bold">Sync</span> across devices</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  emits: ['cancel'],

  setup (_, { emit }) {
    const { getters, state } = useStore()

    const isDarkMode = computed(() => getters.isDarkMode)
    const isDraculaTheme = computed(() => state.settings.settings.theme === 'Dracula')
    const isFreePlan = computed(() => getters.isFreePlan)
    const freePlan = computed(() => getters.freePlan)
    const price = computed(() => parseInt(freePlan.value.price))
    const maxSize = computed(() => (freePlan.value.maxSize / 1048576).toFixed())
    const btnTitle = computed(() => isFreePlan.value ? 'Your current plan' : 'Downgrade')

    function cancel () {
      emit('cancel')
    }

    return {
      // computed
      isDarkMode,
      isDraculaTheme,
      isFreePlan,
      freePlan,
      price,
      maxSize,
      btnTitle,
      // function
      cancel
    }
  }
})
</script>
